module.exports = __webpack_public_path__ + "static/img/title-en.7c00ebc0.png";